// extracted by css-extract-rspack-plugin
export default {"wrapper":"_e4b02b84","printHide":"_feb35f86"};